// SPDX-License-Identifier: GPL-3.0-or-later
import type { IceServer, TurnCredentialsResponse } from '@ffb/shared';
import { FALLBACK_ICE_SERVERS } from '../models/IceConfig.js';

export interface TurnCredentialsClient {
  fetchIceServers(): Promise<IceServer[]>;
}

export interface HttpTurnCredentialsClientOptions {
  baseUrl: string;
  fetchImpl?: typeof fetch;
}

// Тянет iceServers с /turn-credentials. При ошибке отдаёт FALLBACK_ICE_SERVERS —
// хотя бы STUN останется и можно будет пытаться P2P на мягком NAT.
export class HttpTurnCredentialsClient implements TurnCredentialsClient {
  private readonly baseUrl: string;
  private readonly fetchImpl: typeof fetch;

  constructor({ baseUrl, fetchImpl }: HttpTurnCredentialsClientOptions) {
    this.baseUrl = baseUrl.replace(/\/$/, '');
    this.fetchImpl = fetchImpl ?? fetch.bind(globalThis);
  }

  async fetchIceServers(): Promise<IceServer[]> {
    try {
      const res = await this.fetchImpl(`${this.baseUrl}/turn-credentials`, {
        method: 'GET',
        headers: { accept: 'application/json' },
      });
      if (!res.ok) throw new Error(`turn-credentials ${res.status}`);
      const body = (await res.json()) as TurnCredentialsResponse;
      if (!Array.isArray(body.iceServers) || body.iceServers.length === 0) {
        throw new Error('turn-credentials missing iceServers');
      }
      return body.iceServers;
    } catch (err) {
      console.warn('[turn-credentials] fallback to STUN-only:', err);
      return FALLBACK_ICE_SERVERS;
    }
  }
}
